<template>
  <div style="width: 100%">
    <header class="sub-header flex justify-content-between top-header">
      <div class="sub-nav">
        <router-link class="active" :to="{ name: 'projects' }"> Tous les projets </router-link>
      </div>
      <div class="actions d-flex">
        <button v-if="form.token" @click="deleteMethod" style="margin-right: 15px">Supprimer</button>
        <span>Activé</span>
        <ToggleButton v-model="form.is_activated" />
      </div>
    </header>
    <div class="d-flex">
      <div class="col-8 left-side">
        <div class="box-container">
          <div>
            <input name="title" type="text" placeholder="Titre" v-model="form.title" />
          </div>
          <div style="margin-top: 20px">
            <label style="display: block">Type</label>
            <Select
              v-model="form.category"
              :options="[
                { name: 'En cours', value: 'in-progress' },
                { name: 'Habitations', value: 'habitations' },
                { name: 'Transformations', value: 'transformations' },
                { name: 'Immeuble à appartement', value: 'appartments-building' },
                { name: 'Programmes mixtes', value: 'mix' },
              ]"
            />
          </div>
          <div style="margin-top: 20px">
            <label>Date de réalisation</label>
            <input type="text" v-model="form.date" />
          </div>
          <div style="margin-top: 20px">
            <div class="d-flex">
              <div style="margin-right: 2%; flex-basis: 48%">
                <label>Ville</label>
                <input type="text" placeholder="Ville" v-model="form.location" />
              </div>
              <div style="flex-basis: 48%">
                <label>Code postal</label>
                <input type="text" placeholder="Code Postal" v-model="form.postcode" />
              </div>
            </div>
          </div>
          <div style="margin-top: 20px">
            <label>Description</label>
            <textarea style="margin-top: 10px" name="description" class="editor" v-model="form.description" />
          </div>
          <div class="d-flex" style="margin-top: 20px">
            <label style="margin-right: 10px">Nouveau</label>
            <Checkbox v-model="form.is_new" />
          </div>
        </div>
      </div>
      <div class="col-4 right-side">
        <div class="box box-container box-element box-thumbnail" @click="togglePopup">
          <div class="add-thumbnail change-image" v-if="!thumbnail">
            <span>Ajouter une photo</span>
          </div>
          <img :src="thumbnail" alt="Thumbnail" v-else />
          <div class="change-image-label">
            <button class="cta">Gestion des Images</button>
          </div>
        </div>
      </div>
    </div>
    <div class="actions-bar">
      <router-link :to="{ name: 'projects' }" tag="button" class="cancel">Annuler</router-link>
      <button class="cta save fixed-button" @click="save">
        <span class="txt">Enregistrer</span>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import modalBus from "@/bus/modal-bus";
import notifBus from "@/bus/notification-bus";

export default Vue.extend({
  name: "EditProperties",
  components: {},
  computed: {
    citiesFiltered() {
      let province = this.provinces.find((el) => {
        return el.name === this.address.province;
      });
      if (province !== undefined) {
        return this.cities.filter((el) => {
          return el.id.startsWith(province.id);
        });
      }
      return this.cities;
    },
    zonesFiltered() {
      let cities = this.cities.find((el) => {
        return el.name === this.address.city;
      });
      if (cities !== undefined) {
        //this.address.zone = null;
        return this.zones.filter((el) => {
          return el.id.startsWith(cities.id);
        });
      }
      return this.zones;
    },
    thumbnail() {
      if (this.images.ordered.length > 0) {
        return this.images.ordered[0].replace("150x150", "600x350");
      }
      return null;
    },
  },
  data() {
    return {
      form: {
        id: null,
        token: null,
        is_activated: true,
        is_new: 1,
        category: null,
        title: "",
        description: "",
        date: null,
        location: "",
      },
      tags: [],
      address: {
        id: null,
        country: null,
        region: null,
        province: null,
        postcode: null,
        zone: null,
        city: null,
        street: null,
        number: null,
        latitude: null,
        longitude: null,
      },
      images: {
        add: [],
        ordered: [],
        delete: [],
        current: [],
      },
      properties: [],
      projects: [],
    };
  },
  methods: {
    changeTab(tab = "specs") {
      this.tab = tab;
    },
    togglePopup() {
      modalBus.$emit("change", {
        component: "Library",
        data: this.images,
      });
      modalBus.$emit("toggle");
    },
    deleteMethod() {
      this.$axios
        .delete("/api/projects/" + this.form.token)
        .then(() => {
          notifBus.$emit("show", {
            status: "success",
            message: "Projet Supprimé",
          });
          this.$router.push({ name: "projects" });
        })
        .catch((res) => console.log(res));
    },
    save() {
      this.$axios
        .post("/api/projects", {
          project: this.form,
          images: this.images,
        })
        .then((res) => {
          console.log(res.data);
          const message = this.form.id ? this.$t("Projet mis à jour") : this.$t("Projet créé");
          notifBus.$emit("show", {
            status: "success",
            message,
          });
          this.$router.push({ name: "projects" });
        });
    },
  },
  watch: {},
  created() {
    modalBus.$on("library-save-images", (payload) => {
      this.images = payload;
    });

    if (this.$route.params.token)
      this.$axios.get("/api/projects/" + this.$route.params.token).then((res) => {
        let data = { ...res.data.project };
        this.images.current = data.images.map((el) => {
          return this._global.rServer + "s/real/150x150/" + el.url;
        });
        this.images.ordered = this.images.current;
        delete res.data.project.images;
        this.form = res.data.project;
      });
  },
});
</script>
